// ── 미팅링크 소개 페이지 글·영상 (2026-09-28 뼈대 — 임시 문구) ─────────────────────
//   이 파일 하나만 고치면 페이지 내용이 바뀐다. 화면 모양은 LandingPage.jsx.
//   video: 비워 두면 "영상 준비 중" 상자.
//          유튜브 주소(youtube.com/watch?v=… · youtu.be/… · youtube.com/shorts/…)를 넣으면 유튜브 영상,
//          그 밖의 주소(.mp4 등)는 영상 파일로 재생한다.
//   ⚠ 물음표 바로 뒤에 한글을 붙여 쓰면 빌드 글자 검사에 걸린다 — 물음표 뒤에는 띄어쓰기.

export const BRAND = '미팅링크';

export const HERO = {
  eyebrow: '영업팀을 위한 업무 관리',
  title: '콜부터 미팅, 계약까지\n한 곳에서 관리하세요',
  subtitle: '매일의 콜 기록, 미팅 일정과 결과, 계약 현황을 팀 전체가 같은 화면에서 봅니다.',
  video: '',
};

export const FEATURES_TITLE = '미팅링크로 할 수 있는 일';

export const FEATURES = [
  {
    key: 'call', icon: 'Phone', title: '일일콜현황',
    desc: '매일의 콜 기록을 한 곳에 모으고 담당자별·날짜별로 바로 찾아봅니다.',
    video: '',
  },
  {
    key: 'map', icon: 'Map', title: '미팅지도',
    desc: '잡힌 미팅의 일정과 결과를 지도 위에서 한눈에 봅니다.',
    video: '',
  },
  {
    key: 'contract', icon: 'FileText', title: '계약 관리',
    desc: '계약 등록부터 진행 현황까지 빠짐없이 관리합니다.',
    video: '',
  },
  {
    key: 'product', icon: 'Package', title: '상품 관리',
    desc: '판매하는 상품을 등록하고 팀 전체가 같은 목록을 씁니다.',
    video: '',
  },
  {
    key: 'attendance', icon: 'Clock', title: '출퇴근·직원 관리',
    desc: '직원 출퇴근 기록과 근무 현황을 함께 관리합니다.',
    video: '',
  },
];

export const CONTACT = {
  title: '도입 문의',
  subtitle: '미팅링크가 우리 팀에 맞는지 편하게 물어보세요.',
  // value 가 비어 있으면 "준비 중" 으로 보인다. href 는 눌렀을 때 갈 곳(tel:·mailto:·카카오 채널 주소 등).
  items: [
    { key: 'phone', icon: 'Phone', label: '전화', value: '', href: '' },
    { key: 'mail', icon: 'Mail', label: '이메일', value: '', href: '' },
  ],
};
